import React from 'react';
import { DashboardCard } from './DashboardCard';
import { BadgeIcon, WifiIcon, SignalIcon, GlobeIcon, BarChart4Icon, PieChartIcon, ZapIcon, BatteryFullIcon, SettingsIcon, InfoIcon } from 'lucide-react';
export function SubscriptionOverview() {
  // Mock data
  const subscriptionData = {
    active: 991,
    inactive: 348,
    pending: 80,
    total: 1419
  };
  const subscriptionTypes = [{
    name: 'iCRcell',
    active: 932,
    inactive: 244,
    total: 1176
  }, {
    name: 'iTRACKcell',
    active: 65,
    inactive: 0,
    total: 65
  }, {
    name: 'iCRwl',
    active: 357,
    inactive: 0,
    total: 357
  }, {
    name: 'iCPUMPv1',
    active: 4,
    inactive: 0,
    total: 4
  }, {
    name: 'iCPUMP',
    active: 10,
    inactive: 0,
    total: 10
  }];
  const regionSubscriptions = [{
    name: 'Aisco MENA',
    active: 10,
    inactive: 5,
    total: 15
  }, {
    name: 'Aisco AFRICA',
    active: 20,
    inactive: 8,
    total: 28
  }, {
    name: 'Aisco EUROPE',
    active: 820,
    inactive: 250,
    total: 1070
  }, {
    name: 'Aisco AMERICA',
    active: 180,
    inactive: 95,
    total: 275
  }, {
    name: 'Aisco LATAM',
    active: 160,
    inactive: 90,
    total: 250
  }, {
    name: 'Aisco ANZ',
    active: 150,
    inactive: 85,
    total: 235
  }];
  return <div className="space-y-6" data-id="element-2015" data-mp="23fzxekgn7xvd">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2016" data-mp="23grslu6bvtl4">
        <DashboardCard icon={<BadgeIcon size={20} className="text-blue-400" data-id="element-2018" data-mp="1frqje4po8ees" />} title="Subscription Summary" data-id="element-2017" data-mp="1fq5ouf3cwvgx">
          <div className="flex flex-col" data-id="element-2019" data-mp="1asm8n9n3m8mc">
            <div className="flex justify-between items-start mb-6" data-id="element-2020" data-mp="1atozxioc2d2s">
              <div data-id="element-2021" data-mp="1os52cxf5xhf4">
                <div className="text-5xl font-bold text-white" data-id="element-2022" data-mp="1osonso40unxw">
                  {subscriptionData.total}
                </div>
                <div className="text-sm text-blue-300 mt-2" data-id="element-2023" data-mp="306in3temdgqx">
                  Total Subscriptions
                </div>
              </div>
              <div className="flex items-center space-x-4" data-id="element-2024" data-mp="2w3vu3p67pps5">
                <div className="flex items-center" data-id="element-2025" data-mp="1su00idbx78n3">
                  <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-2026" data-mp="1sthxmxur5w67"></div>
                  <span className="text-sm text-blue-300" data-id="element-2027" data-mp="1xs1lx4wtjk1q">Active</span>
                </div>
                <div className="flex items-center" data-id="element-2028" data-mp="22rxr37h95hiv">
                  <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-2029" data-mp="22qcvdej7bsjf"></div>
                  <span className="text-sm text-blue-300" data-id="element-2030" data-mp="26szs9tuqc3nh">Inactive</span>
                </div>
              </div>
            </div>
            <div className="relative h-48" data-id="element-2031" data-mp="1f2mm1dsvd0yx">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-2032" data-mp="1f3o6g8vryztb">
                <div className="relative w-40 h-40" data-id="element-2033" data-mp="1j3ydlovazw9r">
                  <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-2034" data-mp="1j23t2bny2667">
                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#334155" strokeWidth="15" data-id="element-2035" data-mp="1nwhr6ltzqrek" />
                    <circle cx="50" cy="50" r="40" fill="transparent" stroke="#3b82f6" strokeWidth="15" strokeDasharray={`${subscriptionData.active / subscriptionData.total * 251.2} 251.2`} transform="rotate(-90 50 50)" data-id="element-2036" data-mp="rcirdvxnsbk2" />
                  </svg>
                  <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-2037" data-mp="iw9t3k6sdzen">
                    <div className="text-3xl font-bold text-white" data-id="element-2038" data-mp="eu6eimotmep5">
                      {subscriptionData.active}
                    </div>
                    <div className="text-sm text-blue-300" data-id="element-2039" data-mp="9uk2ggkqb4hx">active</div>
                  </div>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 text-lg text-blue-300" data-id="element-2040" data-mp="4ybnp4ag1dba">
                <div className="flex items-center" data-id="element-2041" data-mp="47j2ronhhdd">
                  <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-2042" data-mp="3rbbpplgvv1l9"></div>
                  <span data-id="element-2043" data-mp="3na8an16nt9l3">{subscriptionData.inactive}</span>
                </div>
              </div>
              <div className="absolute bottom-0 right-0 text-lg text-blue-300" data-id="element-2044" data-mp="3ib5d01t0e5n5">
                <div className="flex items-center" data-id="element-2045" data-mp="3id7zwcyv7inn">
                  <div className="w-3 h-3 rounded-full bg-amber-500 mr-1" data-id="element-2046" data-mp="3dd3jso1vcpxy"></div>
                  <span data-id="element-2047" data-mp="1h8dyzm46kwrn">{subscriptionData.pending}</span>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<WifiIcon size={20} className="text-blue-400" data-id="element-2049" data-mp="1m9tj9byjaz8z" />} title="Subscription Types" data-id="element-2048" data-mp="1m77c3dfk2lra">
          <div className="space-y-6" data-id="element-2050" data-mp="17h063x6qiv7h">
            {subscriptionTypes.map((type, index) => <div key={index} className="space-y-2" data-id="element-2051" data-mp="1cgmgzzz3bzd4" data-mpi={index}>
                <div className="flex justify-between items-center" data-id="element-2052" data-mp="yio83a3jgv50">
                  <div className="text-lg font-medium text-white" data-id="element-2053" data-mp="ykip4dbow33t">
                    {type.name}
                  </div>
                  <div className="text-sm text-blue-300" data-id="element-2054" data-mp="oki3gkqclawg">
                    {type.active} active
                    {type.inactive > 0 ? ` / ${type.inactive} inactive` : ''}
                  </div>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-2055" data-mp="2ixzwgn9iuzyv">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${type.active / 1000 * 100}%`
              }} data-id="element-2056" data-mp="2nxm8wuhj0c6m"></div>
                </div>
                <div className="text-xs text-blue-300 text-right" data-id="element-2057" data-mp="7axshblmrf3o">
                  {type.active} of {type.total}
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-2059" data-mp="h8tzpsbg5pwi" />} title="Regional Distribution" data-id="element-2058" data-mp="h9dj7dgqwmcn">
        <div className="flex justify-end mb-6" data-id="element-2060" data-mp="uzz417prf6d6">
          <div className="flex items-center space-x-4" data-id="element-2061" data-mp="uynoybqv6c6r">
            <div className="flex items-center" data-id="element-2062" data-mp="q1xd60m3e2r5">
              <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-2063" data-mp="q15lv1zj2r6o"></div>
              <span className="text-sm text-blue-300" data-id="element-2064" data-mp="14xdacehyyerr">Active</span>
            </div>
            <div className="flex items-center" data-id="element-2065" data-mp="100mthoycbf5a">
              <div className="w-3 h-3 rounded-full bg-slate-600 mr-1" data-id="element-2066" data-mp="zxqv5zikyogb"></div>
              <span className="text-sm text-blue-300" data-id="element-2067" data-mp="36qkvi4k9jqlk">Inactive</span>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-2068" data-mp="31t19gihbq9j2">
          {regionSubscriptions.map((region, index) => <div key={index} className="bg-slate-800/50 rounded-lg p-4" data-id="element-2069" data-mp="3vgpaodz3y50q" data-mpi={index}>
              <div className="flex justify-between items-center mb-3" data-id="element-2070" data-mp="3virx6o11xg0p">
                <div className="text-lg font-medium text-white" data-id="element-2071" data-mp="49mipkbg3upg">
                  {region.name}
                </div>
                <div className="text-sm text-blue-300" data-id="element-2072" data-mp="9asdroskvu25">{region.total}</div>
              </div>
              <div className="space-y-2" data-id="element-2073" data-mp="e8bowftzbqpv">
                <div className="flex justify-between items-center" data-id="element-2074" data-mp="i9xb4rselhcq">
                  <span className="text-xs text-blue-300" data-id="element-2075" data-mp="i82lj066t12b">Active</span>
                  <span className="text-xs text-white" data-id="element-2076" data-mp="n26ufoz0jj61">{region.active}</span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-2077" data-mp="rynkioprw7lr">
                  <div className="bg-blue-500 h-1.5 rounded-full" style={{
                width: `${region.active / region.total * 100}%`
              }} data-id="element-2078" data-mp="x04lslc65w2v"></div>
                </div>
                <div className="flex justify-between items-center" data-id="element-2079" data-mp="2mggv1iticlpj">
                  <span className="text-xs text-blue-300" data-id="element-2080" data-mp="2hh3ww1x6rs7n">Inactive</span>
                  <span className="text-xs text-white" data-id="element-2081" data-mp="2hfsua5fh8qi4">{region.inactive}</span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-1.5 overflow-hidden" data-id="element-2082" data-mp="2ci9doyvb41n0">
                  <div className="bg-slate-600 h-1.5 rounded-full" style={{
                width: `${region.inactive / region.total * 100}%`
              }} data-id="element-2083" data-mp="27kr5xbt0zsgl"></div>
                </div>
              </div>
            </div>)}
        </div>
      </DashboardCard>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2084" data-mp="2vgdg7agov2fu">
        <DashboardCard icon={<SettingsIcon size={20} className="text-blue-400" data-id="element-2086" data-mp="2qi222njd25rt" />} title="Subscription Map" data-id="element-2085" data-mp="2veiqliuh2m5f">
          <div className="relative h-80 bg-slate-900 rounded-lg overflow-hidden flex items-center justify-center" data-id="element-2087" data-mp="3nx68yqi33n2t">
            <div className="text-blue-400 text-lg" data-id="element-2088" data-mp="3j5xxzq13vtnj">
              Map visualization will be displayed here
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<ZapIcon size={20} className="text-blue-400" data-id="element-2090" data-mp="2w9lbxdav4oan" />} title="Subscription Status" data-id="element-2089" data-mp="2rgs8csr4rm05">
          <div className="space-y-6" data-id="element-2091" data-mp="2wbfz6y9lwshw">
            <div className="flex justify-center" data-id="element-2092" data-mp="2iizrhk5rg6an">
              <div className="relative w-40 h-40" data-id="element-2093" data-mp="2ig3txwxtrjmq">
                <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-2094" data-mp="2nghyv644qdgj">
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#0c4a6e" strokeWidth="15" data-id="element-2095" data-mp="3b75b23l2vp8w" />
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#22d3ee" strokeWidth="15" strokeDasharray="251.2 251.2" strokeDashoffset="230" transform="rotate(-90 50 50)" data-id="element-2096" data-mp="3f87c8pyk2bdi" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-2097" data-mp="3679h6x63he72">
                  <div className="text-5xl font-bold text-cyan-300" data-id="element-2098" data-mp="1pszue7hi3xic">1</div>
                  <div className="text-sm text-blue-300" data-id="element-2099" data-mp="1pvvrxupfsk69">Pending</div>
                </div>
              </div>
            </div>
            <div className="bg-slate-800/50 rounded-lg p-4" data-id="element-2100" data-mp="1n8lc03h48toh">
              <div className="text-lg font-medium text-white mb-3" data-id="element-2101" data-mp="1nb7j6203h766">
                Premium Subscriptions
              </div>
              <div className="space-y-4" data-id="element-2102" data-mp="1w9j5vsxubktc">
                <div className="space-y-2" data-id="element-2103" data-mp="1w8hshhtcqm8g">
                  <div className="flex justify-between items-center" data-id="element-2104" data-mp="1raopexnci8ce">
                    <span className="text-sm text-blue-300" data-id="element-2105" data-mp="1rbhmt80ezlhv">iCRcell</span>
                    <span className="text-sm text-white" data-id="element-2106" data-mp="13lx5etjwswap">688 active</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-2107" data-mp="zkk1ip0dn36f">
                    <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: '70%'
                  }} data-id="element-2108" data-mp="1dbyspj4fuaok"></div>
                  </div>
                  <div className="text-xs text-blue-300 text-right" data-id="element-2109" data-mp="kumhml9hczn1">
                    688 active / 244 inactive
                  </div>
                </div>
                <div className="space-y-2" data-id="element-2110" data-mp="fv0388hx1dcn">
                  <div className="flex justify-between items-center" data-id="element-2111" data-mp="2gv16zyvmxe16">
                    <span className="text-sm text-blue-300" data-id="element-2112" data-mp="2gsyg7cmnrgve">iCRwl</span>
                    <span className="text-sm text-white" data-id="element-2113" data-mp="2bx9byvzp1bsr">357 active</span>
                  </div>
                  <div className="w-full bg-slate-700/50 rounded-full h-2 overflow-hidden" data-id="element-2114" data-mp="26vjzdbwtoq2k">
                    <div className="bg-cyan-500 h-2 rounded-full" style={{
                    width: '35%'
                  }} data-id="element-2115" data-mp="22u89d5a1e2tu"></div>
                  </div>
                  <div className="text-xs text-blue-300 text-right" data-id="element-2116" data-mp="1t5gm3afx86p9">
                    357 active / 0 inactive
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </div>
    </div>;
}